// Truncate an article description to the useful prefix by cutting at the
// first spec-section marker, slash-cluster, cross-reference, or offer
// boilerplate. Keeps the product-identifying words (brand + family +
// optional size) and drops everything from the first spec-flag onward.
//
// Example:
//   Duscholux Montage Duschwand E/TmST/TmSTFrt/Rnd/Five Montage 67 Stück
//   488.427020 Allegra 2 Pendeltür mit Festt. AC A-Teil + 488.437020 ...
// becomes:
//   Duscholux Montage Duschwand

const SECTION_MARKER_RE =
  /\s+(Glasart|Breite\s*B|Höhe\s*H|Hoehe\s*H|Profilfarbe|Anschlag|Fertigungs(?:mass|maß)|Türteil|Tuerteil|Grifffarbe|Kunststofffarbe|Wandmontage|Anordnung|LV|Montage\s+\d+\s+Stück|Stk\.|aus\s+Serviceauftrag|aus\s+Auftrag|Dieser\s+Preis\s+gilt|Lieferzeit|zu\s+Position|Positionsangebotsmenge)\b/i;

const SLASH_CLUSTER_RE = /\s+\w+(?:\/\w+){2,}\b/;

const PLUS_REF_RE = /\s+\+\s+\d+[.\-/]/;

export function cleanDescription(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let text = raw.trim();
  if (!text) return null;

  const cuts: number[] = [];
  const section = text.match(SECTION_MARKER_RE);
  if (section?.index !== undefined) cuts.push(section.index);
  const slashCluster = text.match(SLASH_CLUSTER_RE);
  if (slashCluster?.index !== undefined) cuts.push(slashCluster.index);
  const plusRef = text.match(PLUS_REF_RE);
  if (plusRef?.index !== undefined) cuts.push(plusRef.index);

  if (cuts.length > 0) {
    text = text.slice(0, Math.min(...cuts)).trim();
  }

  return text || raw;
}
